<template>
    <div class="combo-box">
        <div class="combo-box-current" :class="{ disabled: !active }" @click.native.stop>
            <v-switch background-color="success" v-model="active" @click.native.stop></v-switch>
            <p class="selected-items" >START SYNC VIEW</p>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                default: false,
            },
        },
        data() {
            return {
                active: false,
            };
        },
        created() {
            this.setDefaultSelectedValues();
        },
        computed: {

            filtersUpdated() {
                return this.$store.state.chart.setChartFilters;
            }
        },
        watch: {
            value() {
                this.active = this.value;
            },
            active() {
                this.active = (this.active !== undefined) ? this.active : 1;
                this.$emit('input', this.active);
            },
        },
        methods: {

            setDefaultSelectedValues() {
                this.active = (this.value !== undefined) ? this.value : 1;
            },
        },
    };
</script>
<style lang="scss">
    @import '../../../style/Charts/Filters/StartSyncViewToggle';
</style>
